import { render, staticRenderFns } from "./ProjectCardBadge.vue?vue&type=template&id=74e377da"
import script from "./ProjectCardBadge.vue?vue&type=script&lang=js"
export * from "./ProjectCardBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports